module.exports = __webpack_public_path__ + "img/invoice_top.36622d59.jpg";